import '../../styles/SolucionesPublicitarias.css';

const EspecialEvents = () => {
  return (
    <section className="especial-events-section">
      <div className='container'>
        <div className='row justify-content-center align-items-center m-1 mb-0'>
          <div className='col-md-6 text-center mt-5 order-2 order-lg-1 d-none'>

            <div className='row text-start position-relative especial-events-img-container z-3'>
              <div className='col-6'>
                <img src="https://dummyimage.com/180x180/2dd067/fff" alt="" className='img-fluid shadow-lg' data-aos="zoom-out" data-aos-delay="0" />
              </div>
              <div className='col-6'>
                <img src="https://dummyimage.com/180x180/2dd067/fff" alt="" className='img-fluid shadow-lg' data-aos="zoom-out" data-aos-delay="200" />
              </div>
            </div>

            <div className='row text-end position-relative especial-events-img-container z-2'>
              <div className='col-6'>
                <img src="https://dummyimage.com/180x180/000/fff" alt="" className='img-fluid shadow-lg' data-aos="zoom-out" data-aos-delay="400" />
              </div>
              <div className='col-6'>
                <img src="https://dummyimage.com/180x180/000/fff" alt="" className='img-fluid shadow-lg' data-aos="zoom-out" data-aos-delay="600" />
              </div>
            </div>

            <div className='row text-start position-relative especial-events-img-container z-3'>
              <div className='col-6'>
                <img src="https://dummyimage.com/180x180/2dd067/fff" alt="" className='img-fluid shadow-lg' data-aos="zoom-out" data-aos-delay="800" />
              </div>
              <div className='col-6'>
                <img src="https://dummyimage.com/180x180/2dd067/fff" alt="" className='img-fluid shadow-lg' data-aos="zoom-out" data-aos-delay="1000" />
              </div>
            </div>

            <div className='row text-end position-relative especial-events-img-container z-4'>
              <div className='col-6'>
                <img src="https://dummyimage.com/180x180/000/fff" alt="" className='img-fluid shadow-lg' data-aos="zoom-out" data-aos-delay="1200" />
              </div>
              <div className='col-6'>
                <img src="https://dummyimage.com/180x180/000/fff" alt="" className='img-fluid shadow-lg' data-aos="zoom-out" data-aos-delay="1400" />
              </div>
            </div>

          </div>

          <div className='col-md-6 mt-0'>
            <img src="assets/eventos-especiales.png" alt="especial events" className='img-fluid' data-aos="fade-down" data-aos-delay="400"/>
          </div>

          <div className='col-md-6 text-center mt-5 order-1 order-lg-2'>
              <div className='pb-2' data-aos="fade-up">
                <h2 className="title"><span>Eventos </span> especiales</h2>
              </div>
              <div>
                <img src="assets/eventos-especiales-logo.png" alt="" className='img-fluid img-filter' data-aos="flip-right" />
              </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EspecialEvents;




